module.exports = __webpack_public_path__ + "media/images/top/scene02-2f158724b7061b52afc158a9d917528d.jpg";